import CitySEOHead from "@/components/feature/CitySEOHead";
import OklahomaCityHeroSection from "./components/HeroSection";
import OKCStickyNav from "./components/StickyNav";
import OKCProcessingTimeSection from "./components/ProcessingTimeSection";
import OKCServicesSection from "./components/ServicesSection";
import OKCLocalAreaSection from "./components/LocalAreaSection";
import OKCTravelTimingSection from "./components/TravelTimingSection";
import OKCDestinationsSection from "./components/DestinationsSection";
import OKCTestimonialsSection from "./components/TestimonialsSection";
import OKCAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import OKCComparisonSection from "./components/ComparisonSection";
import OKCMistakesSection from "./components/MistakesSection";
import OKCHowItWorksSection from "./components/HowItWorksSection";
import OKCFAQSection, { faqs } from "./components/FAQSection";
import OKCHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import OKCFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport", description: "Second passport issuance for frequent travelers and business professionals needing visa flexibility." },
];

export default function OklahomaCityPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Oklahoma City"
        state="Oklahoma"
        stateAbbr="OK"
        route="/cities/oklahoma-city"
        title="Emergency Passport Oklahoma City, OK — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Oklahoma City, OK — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving OKC military families, OU students, business travelers, and families."
        geoPlacename="Oklahoma City, Oklahoma"
        geoPosition="35.4676;-97.5164"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Oklahoma"
        statePageRoute="/states/oklahoma"
      />
      <OklahomaCityHeroSection />
      <OKCStickyNav />
      <OKCProcessingTimeSection />
      <OKCLocalAreaSection />
      <OKCServicesSection />
      <OKCTravelTimingSection />
      <OKCDestinationsSection />
      <OKCTestimonialsSection />
      <OKCAcceptanceFacilitiesSection />
      <OKCComparisonSection />
      <OKCMistakesSection />
      <OKCHowItWorksSection />
      <OKCFAQSection />
      <OKCHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/oklahoma-city" state="OK" />
      <OKCFinalCTA />
    </div>
  );
}